/**
 * 接口域名的管理
 */

const base = process.env

export default base;


// WEBPACK FOOTER //
// ./src/api/libs/base.js